<template>
<div>
    <!-- Filtros de busqueda con boton -->
    <div class="ibox sombra-light">
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Reporte Botones Camapaña
            </h5>
        </div>
        <div class="ibox-content">
            <form @submit.prevent="getreporte">
                <b-overlay :show="buttonDisable" rounded="sm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Fecha de inicio</label>
                                <div class="input-group">
                                    <b-form-datepicker id="fechaInicioGrafico" v-model="form.fechaInicio" placeholder="Fecha de inicio" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Fecha de término</label>
                                <div class="input-group">
                                    <b-form-datepicker id="fechaTerminoGrafico" v-model="form.fechaTermino" placeholder="Fecha de término" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="offset-md-6 col-md-6">
                            <b-button block variant="primary" type="submit" @submit="getreporte" :disabled="buttonDisable" :class="`buscar-info-dashboard`">Buscar</b-button>
                        </div>
                    </div>
                </b-overlay>
            </form>
        </div>
        <transition name="fade">
            <div class="graficos" v-if="mostrarGraficos">
                <div class="ibox sombra-light">
                    <div class="ibox-content">
                        <b-row>
                            <b-col cols="12">
                                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">
                                    <template v-slot:detalles="item">
                                        <div>
                                            <button class="btn btn-primary" @click="abrir(item.data.interacciones)" v-if="item.data.interacciones.length > 0">Detalles</button>
                                        </div>
                                    </template>
                                </data-table>
                                
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </transition>
    </div>

    <Modal ref="Modal" :interacciones="interacciones"></Modal>
</div>
</template>

<script>
var moment = require('moment');
import { labels, locale } from "../../datepicker-intl.json";
import DataTable from '../../DataTableLuis.vue';
import Modal from './modal_numeros.vue';
export default {
    components: { DataTable,Modal },
    data() {
        return {
            interacciones: [],
            form: {
                fechaInicio: moment().subtract(1, "day").format("YYYY-MM-DD"),
                fechaTermino: moment().format("YYYY-MM-DD"),
            },
            datepicker: {
                etiquetas: labels,
                idioma: locale,
            },
            buttonDisable: false,
            parametrosValidos: false,
            mostrarGraficos: false,
            dt: {
                id: 'dt',
                columnas: [
                    { nombre: 'Template', nombre_variable: 'template' },
                    { nombre: 'Boton', nombre_variable: 'boton' },
                    { nombre: 'Cantidad', nombre_variable: 'cantidad' },
                    { nombre: 'Fecha', nombre_variable: 'fecha' },
                    { nombre: 'Campana', nombre_variable: 'nombre_campana' },
                    { nombre: 'Detalles', nombre_variable: 'detalles', slot: 1 },
                ],
                datos: []
            }
        };
    },
    mounted() {
        
    },
    methods: {
        getreporte() {
            // console.log(this.form);
            this.buttonDisable = true;
            this.mostrarGraficos = true;
            this.dt.datos = []
            axios.post('botones_campanas/botones_campanas_reporte', this.form).then(response => {
                console.log(response);
                this.dt.datos = response.data;
                this.buttonDisable = false;
            }).catch(error => {
                this.buttonDisable = false;
                console.log(error);
            })
        },
        abrir(interacciones){
            console.log(interacciones);
            this.interacciones = interacciones;
            this.$refs.Modal.show()

        }
    },
}
</script>
